import AudioAttachment from './AudioAttachment';

export default AudioAttachment;
